import React from 'react';
import PropTypes from 'prop-types';
import styles from './PatternCard.module.css';

export const PatternCard = ({ title, highlightedWord, subtitle }) => {
  return (
    <div className={styles.patternCard}>
      <div className={styles.card} />
      <div className={styles.text}>
        <span className={styles.highlight}>{highlightedWord}</span> {title}
      </div>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>
  );
};

PatternCard.propTypes = {
  title: PropTypes.string.isRequired,
  highlightedWord: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};
